import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { MatchModal } from "../../components";
import EntityMapDialog from "../../components/EntityMapDialog";
import Utterance from "./Utterance";
import FaqUtterance from "./FaqUtterance";

// Library
import _ from "lodash";
import InfiniteScroll from "react-infinite-scroll-component";

// Material helpers
import { 
  withStyles, 
  Typography, 
  List, 
  ListItem, 
  TextField, 
  Divider, 
  Grid, 
  LinearProgress,
  IconButton, 
  DialogActions, 
  DialogContent, 
  DialogTitle, 
  Dialog,
  Button } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import TextTooltip from "./Tooltip";
import Alert from '@material-ui/lab/Alert';

// Style
import styles from "./styles";

class IntentClassification extends React.Component {
  state = {
    dialogOpened: false,
    modalValue: [],
    modalIndex: null,
    matchedQuestions: [],
    tooltipVisible: false,
    tooltipCoordinates: {},
    modalVisible: [false, false],
    activeIndex: null,
    selectedText: "",
    selectedValue: null,
    selectedRole: "",
    selectedOffset: {},
    utterances: [],
    dropdownEntities: null,
    dropdownIntents: null,
    utteranceTouched: [],
    starRating:[],
    processed:[],
    isLoading: false
  }              

  setUpData() {
    const newState = { ...this.state };
    let processed = [...newState.processed, ...this.props.data.map(() => false)];
    let starRating = [...newState.starRating, ...this.props.data.map(() => "0")];
    let ut = [...newState.utteranceTouched, ...this.props.data.map(() => null)];
    let editedIntents = [];
    if (this.props.dropdownIntents) {
      editedIntents = [...this.props.dropdownIntents];
      //delete in future
      editedIntents.forEach((item, index) => {
        if(!item.connection){
          editedIntents[index].connection = "DefaultAction";
          editedIntents[index].name = editedIntents[index].name.replace("AMAZON.", "");
        }
      });
    }
    let utterances = [...newState.utterances, ...this.extractEntities(_.cloneDeep(this.props.data), editedIntents)];
    newState.dropdownIntents = editedIntents;
    newState.processed = processed;
    newState.starRating = starRating;
    newState.utteranceTouched = ut;
    newState.utterances = utterances;
    return newState;
  }

  isNotWhitespace(str) {
    return !(!str || /^\s*$/.test(str));
  }

  extractEntities(data, intents) {
    data.forEach(utterance => {
      let entities = [];
      let text = utterance.UserInput;
      var newTxt = text.split("[");
      let idx = 0;
      for (var i = 1; i < newTxt.length; i++) {
        let startOffset = text.indexOf("[", idx);
        let word = newTxt[i].split(']')[0];
        let entity = text.slice(text.indexOf("{", idx), text.indexOf("}", idx)+1);
        let ent = JSON.parse(entity);
        text = text.replace(`[${word}]${entity}`, word);
        idx = startOffset+word.length;
        if(this.isNotWhitespace(text.charAt(startOffset-1)) || this.isNotWhitespace(text.charAt(startOffset+word.length)))continue;
        entities.push( {entity:ent.entity, value:word, start:startOffset, end:startOffset+word.length, role:ent.role?ent.role:null} ); 
        }
      intents.forEach(item => {
        if (item.id === utterance.Intent) {
          utterance.Intent = item;
        }
      });
      utterance["entities"] = entities;
      utterance["UserInput"] = text;
    });
    return data;
  }

  componentDidMount() {
    const newState = this.props.data ? this.setUpData() : {};
    newState.currentPage = this.props.currentPage;
    newState.rowCount = this.props.rowCount;
    newState.limit = this.props.limit; 
    this.setState(newState);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.data !== this.props.data && this.state.utterances && this.props.data) {
      const newState = this.setUpData();
      this.setState(newState); 
    }
  }

  mapToQuestionDialog = (e, index) => {
    e.preventDefault();
    const newState = { ...this.state };
    newState.dialogOpened = true;
    newState.modalValue = [this.state.utterances[index]["UserInput"]];
    newState.modalIndex = index;
    this.setState(newState);
  };

  closeMapToQuestionDialog = selectedQuestion => {
    const newState = _.cloneDeep(this.state);
    if (selectedQuestion) {
      let found = false;
      const utterance = this.state.utterances[newState.modalIndex];

      //this.props.data[newState.modalIndex].MatchedQuestion = selectedQuestion;
      // update existing value if exist
      _.forEach(newState.matchedQuestions, (value, index) => {
        if (value["Id"] == utterance["Id"] && value["Feedback"] != null) {
          value["MatchedQuestion"] = selectedQuestion;
          newState.processed[newState.modalIndex] = selectedQuestion;
          found = true;
        } else if (value["Id"] == utterance["Id"] && value["SimilarityScore"] != null) {
          value["MatchedQuestion"] = selectedQuestion;
        }
      });
      newState.utteranceTouched[this.state.modalIndex] = "1";
      //add new answer for question
      if (!found) {
        newState.processed[newState.modalIndex] = selectedQuestion;
        newState.matchedQuestions.push({
          Id: utterance["Id"],
          UserInput: utterance["UserInput"],
          MatchedQuestion: selectedQuestion,
          Feedback: "1",
          SimilarityScore: null
        });
      }
    }
    newState.dialogOpened = false;
    newState.modalValue = [];
    newState.modalIndex = null;
    this.setState(newState);
  };

  onStarPopoverClose = (starsNum, index) => {
    if (!starsNum) return;
    const newState = { ...this.state };
    const utterance = this.state.utterances[index];
    let found = false;
    newState.starRating[index] = starsNum;
    newState.utteranceTouched[index] = "1";
    let existingMatchedIndex = -1;
    let newMatchedAnswer = null;
    // update existing value if exist
    _.forEach(newState.matchedQuestions, (value, index) => {
      if (value["Id"] == utterance["Id"] && value["SimilarityScore"] != null) {
        value["SimilarityScore"] = starsNum;
        found = true;
        existingMatchedIndex = index;
      } else if (value["Id"] == utterance["Id"] && value["SimilarityScore"] == null) {
        newMatchedAnswer = value["MatchedQuestion"];
      }
    });
    // add new similarity to the array
    if (!found) {
      newState.matchedQuestions.push({
        Id: utterance["Id"],
        UserInput: utterance["UserInput"],
        MatchedQuestion: newMatchedAnswer ? newMatchedAnswer : utterance["MatchedQuestion"],
        SimilarityScore: starsNum,
        Feedback: null
      });
    } else {
      let tmo = newState.matchedQuestions[existingMatchedIndex];
    }
    this.setState(newState);
  };

  handleRadioChange = (val, index) => {
    const newState = { ...this.state }
    const newTouched = [ ...newState.utteranceTouched ];
    newTouched[index] = val;
    newState.utteranceTouched = newTouched;
    this.setState(newState);
  };

  //from JSON-a to log format
  convertFormat = (utter) => {
    let utterText = [];
    let idx = 0;
    utter.entities.forEach(item => {
      let part = "";
      utterText.push(utter.UserInput.slice(idx, item.start));
      let word = utter.UserInput.slice(item.start, item.end);
      if(item.role){
        part = `[${word}]{"entity":"${item.entity}", "role":"${item.role}"}`;
      }else{
        part = `[${word}]{"entity":"${item.entity}"}`;
      }
      utterText.push(part);
      idx = item.end;
    });
    utterText.push(utter.UserInput.slice(idx));
    return utterText.join("");
  };

  async saveUtteranceFeedback() {
    var { utterances, utteranceTouched, processed } = this.state;
    let editedUtterances = [];

    utterances.forEach((utterance, index) => {
      let intentID = utterance.Intent.id;
      if(utteranceTouched[index]){
        let matchedQuestion, utt, feedback;
        if(["64fc7fcc-65ed-46a8-a94a-18bfc497ff84", "48fcc700-594b-4401-bb9d-fe306b13e24d-AMAZON.FallbackIntent"].includes(intentID)){
          feedback = utteranceTouched[index];
          utt = null;
          matchedQuestion = processed[index] ? processed[index] : utterance["MatchedQuestion"];
        }else if(utteranceTouched[index]==="1"){
          feedback = "0";
          utt = this.convertFormat(utterance);
          matchedQuestion = null;
        }else{
          feedback = "hide";
        }
        editedUtterances.push({
          Id: utterance.Id,
          UserInput: utterance.UserInput,
          Feedback: feedback,
          SimilarityScore: this.state.starRating[index],
          MatchedQuestion: matchedQuestion,
          IntentId: intentID,
          Utterance: utt
        });
      }
    })
    await this.props.saveFeedback(editedUtterances, true);  
  }

  async waitForSaveAndLoadData() {
    await this.saveUtteranceFeedback();
  }

  onSubmitAndLoad = e => {
    e.preventDefault();
    this.waitForSaveAndLoadData();
  };

  //intent func
  getSelected = index => {
    let selectedBlock = window.getSelection();
    let selectedTxt = selectedBlock.toString();
    let range = selectedBlock.getRangeAt(0);
    if (
      !this.isNotWhitespace(selectedTxt) ||
      range.commonAncestorContainer.nodeName === "DIV" ||
      range.cloneContents().querySelectorAll(".entity").length > 1
    )
      return;
    var startNode = range.startContainer.parentNode;
    let startOffset = range.startOffset;
    for (;;) {
      if (startNode.previousSibling === null) break;
      let previousNode = startNode.previousSibling;
      startOffset += previousNode.textContent.length;
      startNode = previousNode; 
    }
    if (selectedTxt[0] === " ") startOffset += 1;
    selectedTxt = selectedTxt.trim();
    let endOffset = startOffset + selectedTxt.length;
    let rect = range.getBoundingClientRect();
    this.setState({
      tooltipVisible: true,
      tooltipCoordinates: { left: rect.left, top: rect.top + window.scrollY, width: rect.width },
      selectedText: selectedTxt,
      selectedOffset: { startOffset: startOffset, endOffset: endOffset },
      activeIndex: index
    });
  };

  openModal = (index, type) => {
    this.setState({
        modalVisible: type==="int"?[false, true]:[true, false], 
        tooltipVisible: false,
        activeIndex: index,
        selectedValue: type==="int"?this.state.utterances[index].Intent:null,
        isLoading: type==="int"?false:true
      })
      if(type!=="int"){
        this.loadEntities();
      }
  }

  closeModal = () => {
    this.setState({
      modalVisible: [false, false]
    });
  };

  closeTooltip = () => {
    this.setState({
      tooltipVisible: false
    });
  };

  loadEntities = async () => {
    await this.props.fetchDropdownEntities();
    this.setState({ isLoading: false});
  } 

  insertEntity = (entities, sIdx, fIdx, role, value) => {
    let offsets = this.state.selectedOffset;
    entities.splice(sIdx, fIdx,
     {entity: value.name,
      role: role,
      start: offsets.startOffset,
      end: offsets.endOffset,
      value: this.state.selectedText
    });
  };

  handleEntityMap = (selectedValue, selectedRole) => {
    if(!selectedValue)return;
    let offsets = this.state.selectedOffset;
    let utt = [...this.state.utterances];
    let item = { ...utt[this.state.activeIndex] };
    let entities = [...item.entities];
    let uttTouched = [...this.state.utteranceTouched];
    uttTouched[this.state.activeIndex] = "1";
    let entNum = entities.length;
    if(entNum>0){
      for(let i = 0;i<entNum;i++){
       if(entities[i].start > offsets.endOffset){
        this.insertEntity(entities,i,0, selectedRole, selectedValue);
        break;
       }else if(entities[i].end > offsets.startOffset){
        this.insertEntity(entities,i,1, selectedRole, selectedValue);
        break;
       }else if(entNum-1 === i){
        this.insertEntity(entities,entNum,0, selectedRole, selectedValue);
        break;}}
    }else{
      this.insertEntity(entities,0,0, selectedRole, selectedValue);
    }
    //ubaci u DB ako je novi entity/role
    if((selectedRole && !selectedValue.role.includes(selectedRole)) || 
    !this.props.dropdownEntities.includes(selectedValue)){
        this.props.saveEntityType(selectedValue, selectedRole);
    }
    item.entities = entities;
    utt[this.state.activeIndex] = item;
    this.setState({
      selectedValue: null,
      utterances: utt,
      utteranceTouched: uttTouched
    })
    this.closeModal();
  };

  handleIntentMap = () => {
    let utt = [...this.state.utterances];
    let src = { ...utt[this.state.activeIndex] };
    let intentList = [...this.state.dropdownIntents];
    let uttTouched = [...this.state.utteranceTouched];
    uttTouched[this.state.activeIndex] = "1";
    if (!intentList.includes(this.state.selectedValue)) {
      let selectedInt = { ...this.state.selectedValue };
      selectedInt.id = require("crypto")
        .createHash("md5")
        .update(this.state.selectedValue.name)
        .digest("hex");
      intentList.push(selectedInt);
      //TODO: update intent list
    }
    src.Intent = this.state.selectedValue;
    utt[this.state.activeIndex] = src;
    this.setState({
      selectedValue: null,
      utterances: utt,
      utteranceTouched: uttTouched,
      dropdownIntents: intentList
    });
    this.closeModal();
  };

  fetchMoreData = () => {
    this.props.loadMoreData(this.state.currentPage * this.state.limit)
     this.setState(prevState => ({ currentPage: prevState.currentPage+1}));
   }

  renderUtteranceData() {
    const { classes,  dropdownEntities} = this.props;
    const { utterances, dropdownIntents, utteranceTouched, selectedValue } = this.state;
   

    if (utterances === null || utterances.length === 0) {
      var error = "";
      if (this.props.utterancesError == 404) {
        error = "No chabot for tenant name";
      } else if (this.props.utterancesError == 500) {
        error = "Internal error while loading data";
      }
      return (
        <Alert severity="info"><Typography color="primary" variant="h6">
          No results found for your specified criteria. Please change your search filter parameters.
        </Typography></Alert>
      );
    }
    return (
      <React.Fragment>
        {this.state.tooltipVisible &&
        <TextTooltip closeTooltip={this.closeTooltip} openModal={ this.openModal } index={this.state.activeIndex} text={"Set entity"} coordinates={this.state.tooltipCoordinates} />
        }
        <Typography variant="h4" component="h4">
          Results:
        </Typography>
        <span className={classes.resultCount}>Total count: { this.props.totalAudits } </span>
        <br /><br /><br /><br />
        <Divider />
        <div className={classes.tableTitles}>
          <Grid container spacing={2}>
            <Grid xs={8} style={{ textAlign: "left" }} item>
              Utterance
            </Grid>
            <Grid xs={2} style={{ textAlign: "center" }} item>
              Intent
            </Grid>
            <Grid xs={2} style={{ textAlign: "right" }} item>
              Actions
            </Grid>
          </Grid>
        </div>
        <Divider />
        <InfiniteScroll
          dataLength={this.state.utterances.length}
          next={this.fetchMoreData}
          style={{ overflow: 'unset'}}
          hasMore={this.props.totalAudits>this.state.utterances.length}
          scrollThreshold={1}
          loader={<LinearProgress style={{marginTop:"-3px"}} variant="indeterminate" color="secondary" />}
        >
       { 
        utterances.map((utterance, index) => {
          const value = this.state.utteranceTouched[index]; 

          if(!["MainFAQIntent", "FallbackIntent"].includes(utterance.Intent.name)){
            return(
            <ListItem key={utterance.Id} className={`${classes.utteranceItem} ${value==="1" ? classes.utteranceSuccess : value === "0"?classes.utteranceDanger:null}`} >
              <Utterance 
                openModal={this.openModal}
                handleSelect={this.getSelected}
                utteranceData={utterance}  
                handleRadio={this.handleRadioChange}
                index={index}
                value={value}
              />
            </ListItem>
         )}else{
            return(
            <ListItem key={utterance.Id} className={`${classes.utteranceItem} ${value==="1" ? classes.utteranceSuccess : value === "0"?classes.utteranceDanger:null}`}>
              <FaqUtterance 
                openModal={this.openModal}
                mapToQuestion={this.mapToQuestionDialog}
                onStarPopoverClose={this.onStarPopoverClose}
                utterance={utterance}  
                handleRadio={this.handleRadioChange}
                index={index}
                value={value}
                starRating={this.state.starRating[index]}
                processed={this.state.processed[index]}
              />
            </ListItem>
         )}}) 
       }
       </InfiniteScroll>
          <div className={classes.trainButton}>
          {(utteranceTouched.includes("0") || utteranceTouched.includes("1"))&&
            <Button variant="contained" color="primary" className={classes.button} onClick={this.onSubmitAndLoad}>
              Train 
            </Button>}
          </div>
        {this.props.totalAudits>this.state.utterances.length?
        <p className={classes.scrollSign}>Scroll to load more utterances</p>:
        <p className={classes.scrollSign}>No more utterances</p>
        }
        {this.state.modalVisible[0]&&
        <EntityMapDialog 
          selectedText={this.state.selectedText}
          closeModal={this.closeModal}
          show={this.state.modalVisible[0]}
          handleEntityMap={this.handleEntityMap}
          isLoading={this.state.isLoading}
        />
        }
        <Dialog open={this.state.modalVisible[1]}>
          <DialogTitle disableTypography className={classes.modalTitle}>
            <Typography variant="h5">Edit intent</Typography>
            {this.closeModal ? (
              <IconButton aria-label="close" className={classes.closeButton} onClick={this.closeModal}>
                <CloseIcon />
              </IconButton>
            ) : null}
          </DialogTitle>
          <DialogContent dividers>
          <Autocomplete
           classes={{
                groupLabel: classes.groupLabel,
            }}
            options={ dropdownIntents?[...dropdownIntents].sort((a,b) => -b.connection.localeCompare(a.connection)):[]}
            getOptionLabel={(option) => {
              if (typeof option === 'string') {
                return option;
              }
              else if (option.inputValue) {
                return option.inputValue;
              }else if(option.name && !option.connection){
              return option.name;
              }
              return option.name + "[" + option.connection + "]";
              }}
            style={{ width: 300 }}
            renderInput={(params) => <TextField {...params} label="Start typing" variant="outlined" />}
            value={this.state.selectedValue}
            groupBy={(option) => option.connection}
            renderOption={(option) => {return option.name;}}
            onChange={(event, newVal) => {
              if( typeof newVal === 'string'){
                this.setState({
                  selectedValue:newVal
                })
              }else if (newVal && newVal.inputValue){
                this.setState({
                  selectedValue:{name:newVal.inputValue}
                })
              }else {
                this.setState({
                  selectedValue:newVal
              })}}}
            /> 
               {/*
            filterOptions={(options, params) => {
            const filtered = filter(options, params);
              if (params.inputValue !== '') {
                filtered.push({
                  	inputValue: params.inputValue,
                    name: `Set "${params.inputValue}" as intent`
                  });
                }
              return filtered;
              }} */}
          </DialogContent>
          <DialogActions>
            <Button autoFocus onClick={this.handleIntentMap} color="primary">
              Save
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }

  render() {
    const { classes } = this.props;
    const { modalValue, dialogOpened } = this.state;

    return (
      <React.Fragment>
        <List dense={true} style={{position:"unset"}} className={classes.list}>
          {this.renderUtteranceData()}
        </List>
        {dialogOpened && (
          <MatchModal
            data={modalValue}
            open={dialogOpened}
            cluster={false}
            parentCloseFunc={this.closeMapToQuestionDialog}
          />
        )}
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    utterancesError: state.utterance["code"],
    totalAudits: !_.isEmpty(state.utterance) ? state.utterance.total : 0,
    dropdownEntities: !_.isEmpty(state.utterance.dropdownEntities) ? state.utterance.dropdownEntities : null, 
    dropdownIntents: !_.isEmpty(state.utterance.dropdownIntents) ? state.utterance.dropdownIntents : null
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators({}, dispatch),
    dispatch
  };
}

IntentClassification = connect(
  mapStateToProps,
  mapDispatchToProps
)(IntentClassification);

export default withStyles(styles)(IntentClassification);
